import { useTheme } from '@mui/material';
import React, { FC } from 'react';
import Chip from 'ui-component/extended/Chip';

interface StatusProps {
    status: number;
}

const NotificationStatus: FC<StatusProps> = ({ status }) => {
    const theme = useTheme();

    const chipcolor = () => {
        switch (status) {
            case 0:
                return {
                    label: 'In corso',
                    chipcolor: 'warning',
                    sx: {
                        color: theme.palette.warning.dark,
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.warning.light
                    }
                };
            case 1:
                return {
                    label: 'Completata',
                    chipcolor: 'success',
                    sx: {
                        color: theme.palette.success.dark,
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.success.light
                    }
                };
            case 2:
                return {
                    label: 'Fallita',
                    chipcolor: 'error',
                    sx: {
                        color: theme.palette.mode === 'dark' ? theme.palette.error.main : theme.palette.error.dark,
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.error.light
                    }
                };
            default:
                return {};
        }
    };

    return <Chip size="small" label="In corso..." {...chipcolor()} />;
};

export default NotificationStatus;
